import * as React from 'react';
import { connect } from 'react-redux';
import { match as Match } from 'react-router';

import { GlobalPrivateState, formatNumber, QueryParameterState, getCountryNameByCode } from 'src/api';

import './../UserList/UserList.scss';
import './Pricing.scss';
import { UserModel, accessoryPartDetails, isoDetails, getPartDetail, isoDetailsArray, CurrencyCodes, getMarketByCountryCode, getValueFromPricings, getNestedPricingProp } from 'franke-trough-dependencies';
import { filterUsersBySword } from '../utils';
import { Button, Tooltip } from 'reactstrap';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { PricingDispatcher } from 'src/app/Container/Dispatcher/PricingDispatcher';
import PricingSwitchView from './PricingSwitchView';
import { getParamByISO } from 'iso-country-currency';
import PeriodSelectionDropdown from '../../Configuration/Checkout/Parts/PeriodSelectionDropdown';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';
import { Link } from 'react-router-dom';
 
export interface PricingsAccessoriesProps {
  match: Match<{pricingId: string}>;
  pricing: GlobalPrivateState['pricing'];
  pricings: GlobalPrivateState['pricings'];
  params: QueryParameterState['params'];
  history: any;
  dispatch: any;
}

export class PricingsAccessoriesPartial extends React.Component<PricingsAccessoriesProps, any> {
  constructor(props: PricingsAccessoriesProps) {
    super(props);

    const state: any = {
      pricing: {
        id: this.pricingId,
        dateFrom: null,
        dateUntil: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
        items: []
      },
      hasChanged: false
    };

    if (this.props.pricing && this.props.pricing.result && this.props.pricing.result.id === this.pricingId) {
      state.pricing = JSON.parse(JSON.stringify(this.props.pricing.result));
    } else if (this.props.pricings && this.props.pricings.result) {
      state.pricing = JSON.parse(JSON.stringify(this.props.pricings.result.find(p => p.id === this.pricingId)));
    }

    this.state = state;
  }

  componentDidUpdate(prevProps: PricingsAccessoriesProps) {
    const prevParams = prevProps.params;
    const params = this.props.params;
    const prevPricing = prevProps.pricing.result;
    const pricing = this.props.pricing.result;
    const pricings = this.props.pricings.result;

    // Finished updating/saving
    const pricingUpdated = this.state.pricing.dateFrom && prevProps.pricing.updating && !this.props.pricing.updating;
    const pricingSwitched = (pricing && pricing.id) && (prevPricing && prevPricing.id) && prevPricing.id !== pricing.id;
    if (pricingUpdated && !pricingSwitched) {
      this.setState({
        showSaved: true
      });

      setTimeout(() => {
        this.setState({
          showSaved: false
        });
      }, 4000);
    }

    // Pricing items...
    // const pricingsUpdated = prevProps.pricings.updating && !this.props.pricings.updating;
    // if (pricingsUpdated) {
    //   const marketPricingsList = pricings && pricings.filter(p => p.type === 'market' && !p.deleted);

    //   if (marketPricingsList) {
    //     console.log(marketPricingsList);
    //     for (const marketPricings of marketPricingsList) {
    //       for (const partKey of partKeys) {
    //         const countryCode = getValueFromPricings(marketPricings, 'country');
    //         const item = {
    //           key: partKey,
    //           value: formatNumber(0, { minimumFractionDigits: 2, maximumFractionDigits: 2}),
    //           countryCode: countryCode.split('-')[0]
    //         }
    //         initialItems.push(item);
    //       }
    //     }
    //   }
    // }

    const paramsChanged = prevParams !== params;
    const noItems = !this.state.pricing.items || this.state.pricing.items.length === 0;
    if (pricing && pricings && (paramsChanged || noItems)) {
      const partKeys = Object.keys(accessoryPartDetails);
			const updatedPricing = JSON.parse(JSON.stringify(pricing));
      const mergedPricingItems = [];
      const marketPricings = pricings.filter(p => p.type === 'market' && !p.deleted);
      const groupKeys = getNestedPricingProp(marketPricings, 'price_list');

      for (const partKey of partKeys) {
        for (let groupKey of groupKeys) {
          const existingItem = mergedPricingItems.find(i => i.key === partKey && i.groupKey === groupKey);
          if (existingItem) continue;

          const item: any = {key: partKey, groupKey };
          const matchingItem = pricing.items && pricing.items.find((i: any) => i.key === partKey && i.groupKey === groupKey);
          
          if (matchingItem) {
            item.value = matchingItem.value;
          } else {
            item.value = '0.00';
          }

          mergedPricingItems.push(item);
        }
      }

      updatedPricing.items = mergedPricingItems;
      console.log('mergedPricingItems', mergedPricingItems);

      this.setState({ pricing: updatedPricing });
    }

    // History usage...
    if (this.pricingId && this.pricingId !== this.state.pricing.id) {
      this.dispatchPricing(this.pricingId);
    }
  }

  public render() {
    const { pricing } = this.state;
    const { params, pricings } = this.props;
    
    const marketPricings = pricings.result && pricings.result.filter(p => p.type === 'market' && !p.deleted);
    const selectedGroupKey: any = this.props.params.groupKey || 'DE';
    const selectedMarketPricing = marketPricings && marketPricings.find(pricing => {
      const priceList = getValueFromPricings(pricing, 'price_list');
      return selectedGroupKey === priceList;
    });
    const currency = selectedMarketPricing && selectedMarketPricing.items.find(i => i.key === 'currency');

		const affectedCountryNames = marketPricings && marketPricings.map(pricing => {
      const priceList = getValueFromPricings(pricing, 'price_list');
			if (selectedGroupKey === priceList) {
				const countryCode = getValueFromPricings(pricing, 'country');
				const countryName = getCountryNameByCode(countryCode) || '';
				return countryName;
			}

      return;
    }).filter(name => name) || [];

    return (
      <div className="partial-pricings-accessories">
        {(!this.props.pricings || !this.props.pricings.result) && (
          <PricingsDispatcher />
        )}
        <PricingDispatcher id={this.state.pricing.id} />
        <div className="partial-pricings-accessories__heading mb-4">
          <h2>
            Prices Accessories
          </h2>
          <div className="partial-pricings-accessories__selector">
            <PeriodSelectionDropdown 
              pricings={this.props.pricings} 
              selectedPeriod={this.state.pricing.id} 
              type="accessories" 
              isDisabled={this.props.pricing.updating}
              onChange={(event: any, type: string) => {
                const newId = event.target.value;
                this.props.history.replace(`/pricings-accessories/${newId}`);
                this.dispatchPricing(newId);
              }}
              label="Time Period" />
          </div>
        </div>
        <div className="container">
          <div className="row view-switcher">
            <div className="col-12 p-0">
              <PricingSwitchView />
            </div>
          </div>
        </div>
				<div className="pricings-affected-countries">
					Markets: {affectedCountryNames.join(', ')}
				</div>
        <ol className="pricings-list">
          <li className="pricings-list__header">
            <span className="pricings-list__cell pricings-list__shortcode">Shortcode</span>
            <span className="pricings-list__cell pricings-list__materialno">Material No.</span>
            <span className="pricings-list__cell pricings-list__name">Designation DE</span>
            <span className="pricings-list__cell pricings-list__price">Price in {currency && currency.value || 'EUR'}</span>
          </li>
          {pricing && pricing.items && pricing.items.map((item: any, index: number) => {
            if (selectedGroupKey !== item.groupKey) { return null }
            
            return (
              <li className="pricings-list__item" key={item.key+item.groupKey}>
                <span className="pricings-list__cell pricings-list__shortcode">{getPartDetail(item.key, 'part_type', 'de')}</span>
                <span className="pricings-list__cell pricings-list__materialno">{getPartDetail(item.key, 'article', 'de')}</span>
                <span className="pricings-list__cell pricings-list__name">{getPartDetail(item.key, 'name', 'de')}</span>
                <span className="pricings-list__cell pricings-list__price">
                  <input 
                    type="text" 
                    value={item.value || ''} 
                    onChange={(e) => this.handleChangeValue(e, index)} 
                    disabled={this.props.pricing.updating} />
                  <div>{currency && currency.value || 'EUR'}</div>
                </span>
              </li> 
            );
          })}
        </ol>

        <div className="pricings-list__cta">
          <Button className="btn" 
            onClick={() => this.handleSave()} 
            disabled={this.props.pricing.updating || !this.state.hasChanged} 
            id="pricings-list__cta-btn">
            <span className="btn-name">
              Save all changes
            </span>
          </Button>
          {this.state.showSaved && (
            <Tooltip
              autohide={false}
              isOpen={true}
              placement="top"
              target="pricings-list__cta-btn"
            >
              {this.props.pricing.error && (
                this.props.pricing.error.message
              ) || (
                <>Changes have been saved successfully</>
              )}
            </Tooltip>
          )}
        </div>
      </div>
    );
  }

  dispatchPricing = (pricingId: string) => {
    this.props.dispatch(requestAPIActions.load(
      'pricing', {
        url: `/Pricings/${pricingId}`
      },
      true
    ));

    this.setState({
      pricing: {
        ...this.state.pricing,
        id: pricingId
      }
    });
  }

  handleSave = () => {
    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>('pricing', {
      url: '/Pricings',
      options: {
        method: 'PATCH',
        data: this.state.pricing,
      }
    }));

    this.setState({
      ...this.state, 
      hasChanged: false
    });
  }

  handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const editedItems = this.state.pricing.items;
    editedItems[index].value = event.target.value;
    // editedItems[index].value = formatNumber(editedItems[index].value, { minimumFractionDigits: 2, maximumFractionDigits: 2});
    editedItems[index].value = editedItems[index].value.replace(',', '.');
    editedItems[index].value = editedItems[index].value.replace(/[^0-9.]/g, '');

    this.setState({
			pricing: {
				...this.state.pricing,
				items: editedItems
			},
			hasChanged: true
		});
  }

  private get pricingId(): string | undefined {
    const { match } = this.props;

    return match && match.params && match.params.pricingId;
  }
}

export const PricingsAccessories = connect((state: GlobalPrivateState) => ({
  pricing: state.pricing,
  pricings: state.pricings,
  params: state.queryState.params,
}))(PricingsAccessoriesPartial);

export default PricingsAccessories;
